var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.243,
    height: 14.986,
    viewBox: "0 0 15.243 14.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#12344d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.626,60.4h-.048a.575.575,0,0,0-.578.578v.064a.575.575,0,0,0,.578.578h.048a.575.575,0,0,0,.578-.578v-.064A.575.575,0,0,0,17.626,60.4Z",
    transform: "translate(-14.689 -51.238)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.226,60.4h-.048a.575.575,0,0,0-.578.578v.064a.575.575,0,0,0,.578.578h.048a.575.575,0,0,0,.578-.578v-.064A.575.575,0,0,0,32.226,60.4Z",
    transform: "translate(-26.947 -51.238)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M46.842,60.4h-.064a.575.575,0,0,0-.578.578v.064a.575.575,0,0,0,.578.578h.064a.575.575,0,0,0,.578-.578v-.064A.575.575,0,0,0,46.842,60.4Z",
    transform: "translate(-39.204 -51.238)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.626,45.6h-.048a.575.575,0,0,0-.578.578v.064a.575.575,0,0,0,.578.578h.048a.575.575,0,0,0,.578-.578v-.064A.575.575,0,0,0,17.626,45.6Z",
    transform: "translate(-14.689 -38.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.226,45.6h-.048a.575.575,0,0,0-.578.578v.064a.575.575,0,0,0,.578.578h.048a.575.575,0,0,0,.578-.578v-.064A.575.575,0,0,0,32.226,45.6Z",
    transform: "translate(-26.947 -38.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M46.842,45.6h-.064a.575.575,0,0,0-.578.578v.064a.575.575,0,0,0,.578.578h.064a.575.575,0,0,0,.578-.578v-.064A.575.575,0,0,0,46.842,45.6Z",
    transform: "translate(-39.204 -38.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M61.442,60.4h-.064a.575.575,0,0,0-.578.578v.064a.575.575,0,0,0,.578.578h.064a.575.575,0,0,0,.578-.578v-.064A.565.565,0,0,0,61.442,60.4Z",
    transform: "translate(-51.462 -51.238)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M76.142,60.4h-.064a.575.575,0,0,0-.578.578v.064a.575.575,0,0,0,.578.578h.064a.575.575,0,0,0,.578-.578v-.064A.575.575,0,0,0,76.142,60.4Z",
    transform: "translate(-63.803 -51.238)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M61.442,45.6h-.064a.575.575,0,0,0-.578.578v.064a.575.575,0,0,0,.578.578h.064a.575.575,0,0,0,.578-.578v-.064A.565.565,0,0,0,61.442,45.6Z",
    transform: "translate(-51.462 -38.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M76.142,45.6h-.064a.575.575,0,0,0-.578.578v.064a.575.575,0,0,0,.578.578h.064a.575.575,0,0,0,.578-.578v-.064A.575.575,0,0,0,76.142,45.6Z",
    transform: "translate(-63.803 -38.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.626,75.1h-.048a.575.575,0,0,0-.578.578v.064a.575.575,0,0,0,.578.578h.048a.575.575,0,0,0,.578-.578v-.064A.586.586,0,0,0,17.626,75.1Z",
    transform: "translate(-14.689 -63.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.226,75.1h-.048a.575.575,0,0,0-.578.578v.064a.575.575,0,0,0,.578.578h.048a.575.575,0,0,0,.578-.578v-.064A.586.586,0,0,0,32.226,75.1Z",
    transform: "translate(-26.947 -63.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M46.842,75.1h-.064a.575.575,0,0,0-.578.578v.064a.575.575,0,0,0,.578.578h.064a.575.575,0,0,0,.578-.578v-.064A.586.586,0,0,0,46.842,75.1Z",
    transform: "translate(-39.204 -63.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M61.442,75.1h-.064a.575.575,0,0,0-.578.578v.064a.575.575,0,0,0,.578.578h.064a.575.575,0,0,0,.578-.578v-.064A.575.575,0,0,0,61.442,75.1Z",
    transform: "translate(-51.462 -63.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M76.142,75.1h-.064a.575.575,0,0,0-.578.578v.064a.575.575,0,0,0,.578.578h.064a.575.575,0,0,0,.578-.578v-.064A.586.586,0,0,0,76.142,75.1Z",
    transform: "translate(-63.803 -63.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.827,8.21h0V6.91a1.791,1.791,0,0,0-1.781-1.8H15.1V4.552a1.252,1.252,0,0,0-2.5,0v.562H7.847V4.552a1.252,1.252,0,1,0-2.5,0v.562H4.4a1.794,1.794,0,0,0-1.8,1.8v9.6a1.791,1.791,0,0,0,1.8,1.781H16.062a1.787,1.787,0,0,0,1.781-1.781l-.016-8.3ZM13.334,4.552a.5.5,0,1,1,.995,0V5.739a.5.5,0,1,1-.995,0Zm-7.252,0a.5.5,0,1,1,.995,0V5.739a.5.5,0,0,1-.995,0Zm-1.7,1.316h.963a1.25,1.25,0,0,0,2.487,0H12.6a1.241,1.241,0,0,0,2.471,0h.963A1.038,1.038,0,0,1,17.057,6.91v.931H3.338V6.91A1.041,1.041,0,0,1,4.381,5.867ZM16.046,17.532H4.381a1.038,1.038,0,0,1-1.043-1.027V8.579H17.073v7.926A1.034,1.034,0,0,1,16.046,17.532Z",
    transform: "translate(-2.6 -3.3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b72f749e5857b28976b5421999297416.svg";
export { ForwardRef as ReactComponent };